import { AmplitudeExperimentsContext } from '@/components/AmplitudeExperimentsProvider/Context';
import { useCallback, useContext } from 'react';

export const useAmplitudeExperiments = () => {
    return useContext(AmplitudeExperimentsContext);
};

export const useAmplitudeFeatureFlag = (featureFlagKey: string, featureFlagVariant: string) => {
    const { client, variants } = useAmplitudeExperiments();

    const shouldExposeFeature = Boolean(variants[featureFlagKey]?.value);
    const isShowingFeature = variants[featureFlagKey]?.value === featureFlagVariant;

    const trackFeatureFlag = useCallback(() => {
        if (process.env.NODE_ENV === 'test') {
            // Don't track exposure in tests
            return;
        }

        if (!client) {
            console.error('useAmplitudeFeatureFlag - client is not initialized');
            return;
        }

        // track user exposure to the experiment if they are in it + the test is running in amplitude
        if (shouldExposeFeature) {
            // Wait for identify in AmplitudeProvider.tsx to be called
            setTimeout(() => {
                client.exposure(featureFlagKey);
            }, 1000);
        }
    }, [client, featureFlagKey, shouldExposeFeature]);

    return {
        isShowingFeature,
        trackFeatureFlag,
    };
};
